/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import './AttachRate.scss';
import { getDataForAttachRate } from '../../helper/helper';
import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import Loader from '../../components/Loader/Loader';
import CustomButton from '../../components/ui/Button/Button';
import MonthSelector from '../../components/ui/MonthSelector';
import DataUnavailableMessage from '../../components/ui/DataUnavailableMessage';
import AttachRateTable from './AttachRateTable';
import { capitalizeFirstLetter, monthNames } from './utils';
import { storeNameList } from '../utils';
//import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';


export const ALL_EMPLOYEE = 'All Employee';
const ALL_STORE = 'All Store';

const AttachRate = () => {
  const userDetail = JSON.parse(localStorage.getItem('user_data') || '{}');
  const userdata = userDetail;
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [aRArray1, setARArray1] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [filterEmp, setFilterEmp] = useState([]);
  const [storesList, setStoresList] = useState([]);
  const [employeName, setEmployeName] = useState(ALL_EMPLOYEE);
  const [storeName, setStoreName] = useState('');
  const [filterData, setFilterData] = useState({});

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    async function fetchUser() {
      setARArray1({});
      setIsLoading(true);
      const username = localStorage.getItem('username');

      try {
        const { data } = await getDataForAttachRate(
          {
            startDate,
            endDate,
            username,
          },
          signal, // Pass the abort signal
        );

        // const flatarr = {...data.aRArray1.employees, ...data.aRArray1.stores}
        const adminUser = 'admin@vyadom.com';
        if (data && data.aRArray1) {
          setARArray1(data.aRArray1);
          setFilterEmp(
            data.filterEmp.filter((emp) => emp !== adminUser).sort((a, b) => a.localeCompare(b)),
          );
          setStoresList(
            data.storesList.sort((a, b) => storeNameList[a].localeCompare(storeNameList[b])),
          );
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('Previous request aborted');
        } else {
          console.error('API fetch error:', error);
        }
      } finally {
        setIsLoading(false);
      }
    }

    if (startDate !== '' && endDate !== '') {
      fetchUser();
    }

    // Cleanup function to abort previous request
    return () => controller.abort();
  }, [startDate, endDate]);

  const handleEmployeeNameChange = (e) => {
    e.preventDefault();
    setStoreName('');
    setEmployeName(e.target.value);
  };

  // jjjjjjjjjjjjjj
  const handleStoreNameChange = (e) => {
    e.preventDefault();
    setEmployeName('');
    setStoreName(e.target.value);
  };

  const roundValues = (dataArray, keys) => {
    return dataArray.map((item) => {
      keys.forEach((key) => {
        if (item.hasOwnProperty(key)) {
          item[key] = item[key] ? parseFloat(item[key].toFixed(2)) : 0;
        }
      });
      return item;
    });
  };

  const downloadCSV = () => {
    const outputs = filterData.map(([key, value]) => {
      const email = key;
      const data = value;
      let store = (data) => {
        return [{ email: storeNameList[data] }];
      };
      let emailOutput = [{ email }];
      let data1 = emailOutput[0].email.length === 7 ? store(emailOutput[0].email) : emailOutput;
      const actKeys = [
        {
          act: 'Act',
          actCount: 'Accessory Attached',
          actARate: 'Attach Rate(%)',
          actCost: 'Cost($)',
          actMSRP: 'MSRP($)',
          actDiscount: 'Discount($)',
          actSf: 'Sold for($)',
          actPm: 'Profit Margin($)',
          accActNumber: 'Accessories Numbers',
          accActNumRate: 'Accessories Numbers Rate(%)',
        },
      ];
      const actOutput = [
        {
          act: data.act,
          actCount: data.actCount,
          actARate: data.actARate,
          ...data.actSum,
          actSf: data.actSf,
          actPm: data.actPm,
          accActNumber: data.accActNumber,
          accActNumRate: data.accActNumRate,
        },
      ];
      const keysToRound = [
        'accActNumRate',
        'cost',
        'discount',
        'actARate',
        'actPm',
        'actSf',
        'msrp',
      ];
      const roundedDataAct = roundValues(actOutput, keysToRound);
      const hupKeys = [
        {
          hup: 'Hup',
          hupCount: 'Accessory Attached',
          hupAr: 'Attach Rate(%)',
          hupCost: 'Cost($)',
          hupMSRP: 'MSRP($)',
          hupDiscount: 'Discount($)',
          hupSf: 'Sold for($)',
          hupPm: 'Profit Margin($)',
          accHupNumber: 'Accessories Numbers',
          accHupNumRate: 'Accessories Numbers Rate(%)',
        },
      ];
      const hupOutput = [
        {
          hup: data.hup,
          hupCount: data.hupCount,
          hupARate: data.hupARate,
          ...data.hupSum,
          hupSf: data.hupSf,
          hupPm: data.hupPm,
          accHupNumber: data.accHupNumber,
          accHupNumRate: data.accHupNumRate,
        },
      ];
      const keysToRoundHup = [
        'accHupNumRate',
        'cost',
        'discount',
        'hupARate',
        'hupPm',
        'hupSf',
        'msrp',
      ];

      const roundedDataHup = roundValues(hupOutput, keysToRoundHup);
      const actPPPKeys = [{ act: 'Act', actPPP: 'Act with PPP', actPPPRate: 'PPP Rate(%)' }];
      const actPPPOutput = [
        {
          act: data.act,
          actPPP: data.actPPP,
          actPPPRate: data.actPPPRate,
        },
      ];
      const keysToRoundActPPP = ['actPPPRate'];
      const roundedDataActPPP = roundValues(actPPPOutput, keysToRoundActPPP);
      const hupPPPKeys = [{ hup: 'Hup', hupPPP: 'Hup with PPP', hupPPPRate: 'PPP Rate(%)' }];
      const hupPPPOutput = [
        {
          hup: data.hup,
          hupPPP: data.hupPPP,
          hupPPPRate: data.hupPPPRate,
        },
      ];
      const keysToRoundHupPPP = ['hupPPPRate'];
      const roundedDataHupPPP = roundValues(hupPPPOutput, keysToRoundHupPPP);
      const actWDKeys = [{ act: 'Act', actWD: 'Act with Device', actWDRate: 'Device Rate(%)' }];
      const actWDOutput = [
        {
          act: data.act,
          actWD: data.actWD,
          actWDRate: data.actWDRate,
        },
      ];
      const keysToRoundActWD = ['actWDRate'];
      const roundedDataActWD = roundValues(actWDOutput, keysToRoundActWD);

      return {
        data1,
        actKeys,
        roundedDataAct,
        hupKeys,
        roundedDataHup,
        actPPPKeys,
        roundedDataActPPP,
        hupPPPKeys,
        roundedDataHupPPP,
        actWDKeys,
        roundedDataActWD,
      };
    });

    const combinedData = [];
    Object.values(outputs).forEach((output) => {
      Object.values(output).forEach((obj) => {
        combinedData.push(Object.values(...obj));
      });
    });
    const csvContent =
      'data:text/csv;charset=utf-8,' +
      combinedData.map((row) => Object.values(row).join(',')).join('\n');

    const [startYear, Month] = startDate.split('-');
    const startMonthIndex = parseInt(Month, 10) - 1; // Convert month number to zero-based index
    const startMonth = monthNames[startMonthIndex];

    let fileName = '';
    if (employeName && employeName !== ALL_EMPLOYEE) {
      const firstEmail = filterData[0][0];
      const emailFirstName =
        firstEmail.split('@')[0].charAt(0).toUpperCase() +
        firstEmail.split('@')[0].slice(1).toLowerCase();
      fileName = `${emailFirstName}_${startMonth}_${startYear}.csv`;
    } else if (storeName && storeName !== ALL_STORE) {
      fileName = `${storeNameList[storeName]}_${startMonth}_${startYear}.csv`;
    } else if (employeName === ALL_EMPLOYEE) {
      fileName = `All_Employees_${startMonth}_${startYear}.csv`;
    } else if (storeName === ALL_STORE) {
      fileName = `All_Stores_${startMonth}_${startYear}.csv`;
    } else {
      fileName = `${startMonth}_${startYear}.csv`;
    }
    // Create a link element and trigger the download
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  };

  const handleMonthChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  useEffect(() => {
    const filteredData =
      aRArray1 && aRArray1?.employees
        ? employeName === ALL_EMPLOYEE
          ? aRArray1?.employees
          : storeName === ALL_STORE
          ? aRArray1?.stores
          : employeName !== ALL_EMPLOYEE && employeName !== ''
          ? { [employeName]: aRArray1?.employees[employeName] }
          : { [storeName]: aRArray1?.stores[storeName] }
        : {};
    const formatedResults = Object.entries(filteredData);
    const sortedResults = [...formatedResults].sort((a, b) => {
      const aValue = a[1].OAPlusrevperH ? parseFloat(a[1].OAPlusrevperH.toFixed(2)) : 0;
      const bValue = b[1].OAPlusrevperH ? parseFloat(b[1].OAPlusrevperH.toFixed(2)) : 0;
      return bValue - aValue;
    });
    setFilterData(sortedResults);
  }, [aRArray1, employeName, storeName]);

  return (
    <div className="ar-main">
      <div className="ar-container">
        {/* <div className="ar-block"> */}
        <div className="ar-block-container">
          <div className="filter-menu-list">
            <div className="filter-menu date-selection">
              <MonthSelector
                onMonthChange={handleMonthChange}
                inputProps={{ disabled: isLoading }}
              />
            </div>

            {filterEmp?.length > 0 && storesList?.length > 0 && (
              <>
                {userDetail?.role !== 'employee' && (
                  <div className="filter-menu">
                    <div className="filter-datemenu">
                      <FormControl fullWidth> 
                        <InputLabel htmlFor="employeeFilter">Select Employee</InputLabel>
                        <Select
                          value={employeName}
                          onChange={handleEmployeeNameChange}
                          className="filter-datemenu-select"
                          label="Select Employee"
                          inputProps={{
                            id: 'employeeFilter',
                          }}
                        >
                          <MenuItem value={ALL_EMPLOYEE}>
                            <em>All Employee</em>
                          </MenuItem>
                          {filterEmp &&
                            filterEmp?.map((name, index) => (
                              <MenuItem key={index} value={name}>
                                {capitalizeFirstLetter(name, userdata)}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                )}
                <div className="filter-menu">
                  <div className="filter-datemenu">
                    <FormControl fullWidth>
                      <InputLabel htmlFor="storeFilter" id="store-label">
                        Select Store
                      </InputLabel>
                      <Select
                        labelId="store-label"
                        value={storeName}
                        onChange={handleStoreNameChange}
                        className="filter-datemenu-select"
                        label="Select Store:"
                        inputProps={{
                          id: 'storeFilter',
                        }}
                      >
                        {storesList.length !== 1 && (
                          <MenuItem value={ALL_STORE}>
                            <em>All Stores</em>
                          </MenuItem>
                        )}
                        {storesList &&
                          storesList?.map((name, index) => (
                            <MenuItem key={index} value={name}>
                              {storeNameList[name]}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="topbuttons">
                  {/* <CustomButton buttonType="download" disabled={isLoading} onClick={downloadCSV} />
                */}
                 <CustomButton
                    btnLabel="download"
                    buttonType='success'
                    onClick={downloadCSV}
                    customIcon={<CloudDownloadIcon />}
                    type="submit"
                    disabled={isLoading} 
                  />
                </div>
              </>
            )}
          </div>
          {isLoading ? (
            <Loader />
          ) : !aRArray1?.stores && !aRArray1?.employees ? (
            <DataUnavailableMessage selectedMonth={startDate} />
          ) : (
            <AttachRateTable results={filterData} userDetail={userDetail} />
          )}
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default AttachRate;
